// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabBarStep-progressContainer-UfcpX {
	display: block;
	overflow: hidden;
	position: relative;
	width: 100%;
}

.TabBarStep-linkReset-oHTPl {
	text-decoration: none;
	color: inherit;
}

.TabBarStep-progressStep-SiuMW {
	padding-left: 8px;
	color: var(--primary-foreground);
	line-height: 36px;
	font-size: 13px;
	white-space: nowrap;
}

.TabBarStep-progressStyle-x7TZb {
	border: 1px solid #2ECC8F;
	border-radius: 22px;
	padding: 2px 12px;
	display: grid;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-template-columns: 28px auto;
	gap: 8px;
	cursor: pointer;
}

a:hover,
a:focus,
a:active {
	color: var(--primary-link-foreground);

}

.TabBarStep-active-omyya,
.TabBarStep-linkReset-oHTPl:hover {
	color: #0099FF;
	background-color: rgba(0, 153, 255, 0.12);
	border: 1px solid #0099FF;
}

.TabBarStep-active-omyya,
.TabBarStep-linkReset-oHTPl:focus {
	color: #0099FF;
	background-color: rgba(0, 153, 255, 0.12);
	border: 1px solid #0099FF;
}

.TabBarStep-iconCss-HO27C {
	width: 28px;
	height: 28px;
	background-color: var(--secondary-gray-bg);
	border-radius: 100%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.TabBarStep-iconCss-HO27C img {
	width: 16px;
	height: 16px;
	-o-object-fit: contain;
	   object-fit: contain;
}

.TabBarStep-active-omyya .TabBarStep-iconCss-HO27C {
	background-color: var(--common-white-primary-bg);
}

.TabBarStep-linkReset-oHTPl:hover .TabBarStep-iconCss-HO27C,
.TabBarStep-linkReset-oHTPl:focus .TabBarStep-iconCss-HO27C {
	background-color: var(--common-white-primary-bg);
}

.TabBarStep-arrowPrev-ABu2E {
	position: absolute;
	top: 2px;
	left: 12%;
}

.TabBarStep-arrowNext-FA09H {
	position: absolute;
	top: 2px;
	right: 12%;
}

.TabBarStep-arrowCenter-zjc8f img {
	width: 64px;
}

@media screen and (min-width:1301px) and (max-width:1410px) {
	.TabBarStep-arrowPrev-ABu2E {
		left: 8%;
	}

	.TabBarStep-arrowNext-FA09H {
		right: 8%;
	}
}

@media (max-width: 1300px) {
	.TabBarStep-arrowCenter-zjc8f {
		display: none;
	}
}

@media (max-width: 767px) {
	.TabBarStep-progressStep-SiuMW {
		font-size: 11px;
		padding-left: 4px;
		line-height: 28px;
	}

	.TabBarStep-progressStyle-x7TZb {
		padding: 2px 8px;
		grid-template-columns: 22px auto;
		gap: 4px;
	}

	.TabBarStep-iconCss-HO27C {
		width: 22px;
		height: 22px;
	}

	.TabBarStep-iconCss-HO27C img {
		width: 12px;
		height: 12px;
	}

	.TabBarStep-arrowPrev-ABu2E {
		left: 0;
	}

	.TabBarStep-arrowNext-FA09H {
		right: 0;
	}

	.TabBarStep-arrowCenter-zjc8f {
		display: none;
	}
}

@media (max-width: 480px) {
	.TabBarStep-progressStep-SiuMW {
		font-size: 10px;
		padding-left: 2px;
	}

	.TabBarStep-progressStyle-x7TZb {
		padding: 2px 6px;
		grid-template-columns: 18px auto;
		gap: 3px;
	}

	.TabBarStep-iconCss-HO27C {
		width: 18px;
		height: 18px;
	}

	.TabBarStep-iconCss-HO27C img {
		width: 10px;
		height: 10px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ListPlaceStep1/TabBarStep.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,gCAAgC;CAChC,iBAAiB;CACjB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;CACjB,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,gCAAgC;CAChC,QAAQ;CACR,eAAe;AAChB;;AAEA;;;CAGC,qCAAqC;;AAEtC;;AAEA;;CAEC,cAAc;CACd,yCAAyC;CACzC,yBAAyB;AAC1B;;AAEA;;CAEC,cAAc;CACd,yCAAyC;CACzC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,0CAA0C;CAC1C,mBAAmB;CACnB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;AACpB;;AAEA;CACC,gDAAgD;AACjD;;AAEA;;CAEC,gDAAgD;AACjD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC;EACC,QAAQ;CACT;;CAEA;EACC,SAAS;CACV;AACD;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;EAChB,gCAAgC;EAChC,QAAQ;CACT;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,OAAO;CACR;;CAEA;EACC,QAAQ;CACT;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;EAChB,gCAAgC;EAChC,QAAQ;CACT;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,WAAW;EACX,YAAY;CACb;AACD","sourcesContent":[".progressContainer {\n\tdisplay: block;\n\toverflow: hidden;\n\tposition: relative;\n\twidth: 100%;\n}\n\n.linkReset {\n\ttext-decoration: none;\n\tcolor: inherit;\n}\n\n.progressStep {\n\tpadding-left: 8px;\n\tcolor: var(--primary-foreground);\n\tline-height: 36px;\n\tfont-size: 13px;\n\twhite-space: nowrap;\n}\n\n.progressStyle {\n\tborder: 1px solid #2ECC8F;\n\tborder-radius: 22px;\n\tpadding: 2px 12px;\n\tdisplay: grid;\n\talign-items: center;\n\tgrid-template-columns: 28px auto;\n\tgap: 8px;\n\tcursor: pointer;\n}\n\na:hover,\na:focus,\na:active {\n\tcolor: var(--primary-link-foreground);\n\n}\n\n.active,\n.linkReset:hover {\n\tcolor: #0099FF;\n\tbackground-color: rgba(0, 153, 255, 0.12);\n\tborder: 1px solid #0099FF;\n}\n\n.active,\n.linkReset:focus {\n\tcolor: #0099FF;\n\tbackground-color: rgba(0, 153, 255, 0.12);\n\tborder: 1px solid #0099FF;\n}\n\n.iconCss {\n\twidth: 28px;\n\theight: 28px;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder-radius: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.iconCss img {\n\twidth: 16px;\n\theight: 16px;\n\tobject-fit: contain;\n}\n\n.active .iconCss {\n\tbackground-color: var(--common-white-primary-bg);\n}\n\n.linkReset:hover .iconCss,\n.linkReset:focus .iconCss {\n\tbackground-color: var(--common-white-primary-bg);\n}\n\n.arrowPrev {\n\tposition: absolute;\n\ttop: 2px;\n\tleft: 12%;\n}\n\n.arrowNext {\n\tposition: absolute;\n\ttop: 2px;\n\tright: 12%;\n}\n\n.arrowCenter img {\n\twidth: 64px;\n}\n\n@media screen and (min-width:1301px) and (max-width:1410px) {\n\t.arrowPrev {\n\t\tleft: 8%;\n\t}\n\n\t.arrowNext {\n\t\tright: 8%;\n\t}\n}\n\n@media (max-width: 1300px) {\n\t.arrowCenter {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.progressStep {\n\t\tfont-size: 11px;\n\t\tpadding-left: 4px;\n\t\tline-height: 28px;\n\t}\n\n\t.progressStyle {\n\t\tpadding: 2px 8px;\n\t\tgrid-template-columns: 22px auto;\n\t\tgap: 4px;\n\t}\n\n\t.iconCss {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t}\n\n\t.iconCss img {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t}\n\n\t.arrowPrev {\n\t\tleft: 0;\n\t}\n\n\t.arrowNext {\n\t\tright: 0;\n\t}\n\n\t.arrowCenter {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.progressStep {\n\t\tfont-size: 10px;\n\t\tpadding-left: 2px;\n\t}\n\n\t.progressStyle {\n\t\tpadding: 2px 6px;\n\t\tgrid-template-columns: 18px auto;\n\t\tgap: 3px;\n\t}\n\n\t.iconCss {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t}\n\n\t.iconCss img {\n\t\twidth: 10px;\n\t\theight: 10px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressContainer": `TabBarStep-progressContainer-UfcpX`,
	"linkReset": `TabBarStep-linkReset-oHTPl`,
	"progressStep": `TabBarStep-progressStep-SiuMW`,
	"progressStyle": `TabBarStep-progressStyle-x7TZb`,
	"active": `TabBarStep-active-omyya`,
	"iconCss": `TabBarStep-iconCss-HO27C`,
	"arrowPrev": `TabBarStep-arrowPrev-ABu2E`,
	"arrowNext": `TabBarStep-arrowNext-FA09H`,
	"arrowCenter": `TabBarStep-arrowCenter-zjc8f`
};
module.exports = ___CSS_LOADER_EXPORT___;
